// extracted by mini-css-extract-plugin
export default {"tableHeader":"SendPalletsTable_tableHeader__Jza1e","withEmptyColumn":"SendPalletsTable_withEmptyColumn__n8UV2"};